import { PlaneTypes } from '../Model/ModelTypes';

// @ts-expect-error
export const transparencyColors: Record<PlaneTypes | 'default', string> = {
  [PlaneTypes.Card_BigBrowse_Bookend]: '#cccccc',
  [PlaneTypes.Card_BigBrowse_Product]: '#eeeeee',
  [PlaneTypes.Card_ShopFloor_Hero]: '#cccccc',
  [PlaneTypes.Card_ShopFloor_Product]: '#eeeeee',
  [PlaneTypes.Grid_SingleSectionView]: '#eeeeee',
  [PlaneTypes.Card_SingleSectionView_Hero]: '#eee',
  [PlaneTypes.Card_SingleSectionView_Product]: '#eeeeee',
  [PlaneTypes.Card_SingleSectionView_Description]: '#eeeeee',
  [PlaneTypes.Card_SingleSectionView_Subtitle]: '#eeeeee',
  [PlaneTypes.Card_MultiSection_Hero]: '#cccccc',
  [PlaneTypes.Card_MultiSection_SectionHero]: '#cccccc',
  [PlaneTypes.Card_MultiSection_SectionHero_Small]: '#cccccc',
  [PlaneTypes.Card_MultiSection_Footer_Item]: '#cccccc',
  [PlaneTypes.Card_MultiSection_Footer_Item_Small]: '#cccccc',
  [PlaneTypes.Card_MultiSection_Description]: '#eeeeee',
  [PlaneTypes.Card_MultiSection_Description_Title_Small]: '#eeeeee',
  [PlaneTypes.Card_MultiSection_Description_Body_Small]: '#eeeeee',
  [PlaneTypes.Card_MultiSection_Product]: '#eeeeee',
  [PlaneTypes.Card_MultiSection_Subtitle]: '#eeeeee',
  [PlaneTypes.Card_Background_Plane]: '#eeeeee',
  [PlaneTypes.Gap]: '#eeeeee',
  [PlaneTypes.Card_SingleSectionView_Description_Body]: '',
  [PlaneTypes.Card_MultiSection_SectionHero_Small_Title]: '',
  [PlaneTypes.Card_MultiSection_SectionHero_Small_Description]: '',
  [PlaneTypes.Card_MultiSection_Description_Small]: '',
  [PlaneTypes.Card_MultiSection_Description_Body_Ultra_Small]: '',
  [PlaneTypes.Card_MultiSection_Description_Title]: '',
  [PlaneTypes.Card_MultiSection_Description_Title_Ultra_Small]: '',
  [PlaneTypes.Card_MultiSection_Subtitle_Ultra_Small]: '',
  [PlaneTypes.Layout_Merchandiser]: '',
  [PlaneTypes.Layout_ThreeUp]: '',
  [PlaneTypes.Layout_HeroAndText_ImagePart]: '',
  [PlaneTypes.Layout_HeroAndText_TextPart]: '',
  default: '',
};
